import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuthApis from "../auth/useAuthApis";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { FaAngleDoubleLeft } from "react-icons/fa";

const Login = () => {
  const [empID, setEmpID] = useState("");
  const [password, setPassword] = useState("");
  const [empIdError, setEmpIdError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [apiError, setApiError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const { loginWithGmail, data: loginResponseData, loading, apiError: responseApiError } = useAuthApis();

  useEffect(() => {
    if (loginResponseData?.success && loginResponseData?.token) {
      localStorage.setItem("employeeDetails", JSON.stringify(loginResponseData));
      navigate("/sidebar/home");
    } else if (loginResponseData?.success === false) {
      setApiError(loginResponseData?.message || "Login failed. Please try again.");
    } else if (responseApiError) {
      setApiError(responseApiError || "Something went wrong. Please try again.");
    }
  }, [loginResponseData, navigate, responseApiError]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setEmpIdError("");
    setPasswordError("");
    setApiError("");

    if (!empID) return setEmpIdError("Enter Employee ID");
    if (!password) return setPasswordError("Enter Password");
    if (password.length < 6) return setPasswordError("Password must be more than 6 characters");

    loginWithGmail({ payload: { emp_id: empID.trim(), password: password.trim() } });
  };

  const toggleShowPassword = () => setShowPassword((prev) => !prev);

  return (
    <div className="min-h-screen bg-white relative flex items-end justify-center px-4">
      {/* Top decorative circles */}
      <div className="absolute top-0 left-0 w-full h-80 overflow-hidden z-0">
        <div className="absolute w-[500px] h-[500px] bg-green-200 rounded-full -top-2/3 -left-40 opacity-80"></div>
        <div className="absolute w-[400px] h-[400px] bg-green-600 rounded-full -top-2/3 -right-10 opacity-70"></div>
        {/* Centered OHM HRMS Text */}
        <div className="absolute top-16 left-1/2 transform -translate-x-1/2 z-10">
          <h1 className="text-white text-2xl md:text-3xl text-center font-extrabold tracking-wide">
            OHM HRMS
          </h1>
        </div>
      </div>

      {/* Login form card */}
      <div className="px-8 mb-24 md:p-10 max-w-md w-full animate-fadeIn z-10">
        <div className="text-center mb-6">
          <img
            src="/WebIcon.png"
            alt="Logo"
            className="w-42 h-30 mx-auto mb-2"
          />
          <p className="text-xl font-semibold text-green-700">Welcome Back</p>
        </div>

        {apiError && <p className="text-red-600 text-center text-sm mb-2">{apiError}</p>}

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Employee ID */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Employee ID</label>
            <input
              type="text"
              value={empID}
              onChange={(e) => setEmpID(e.target.value)}
              placeholder="Enter Employee ID"
              className="w-full px-4 py-2 border border-green-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
            />
            {empIdError && <p className="text-red-500 text-xs mt-1">{empIdError}</p>}
          </div>

          {/* Password */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter Password"
                className="w-full px-4 py-2 pr-10 border border-green-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              />
              <span
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-green-600 cursor-pointer"
                onClick={toggleShowPassword}
              >
                {showPassword ? <AiOutlineEyeInvisible size={20} /> : <AiOutlineEye size={20} />}
              </span>
            </div>
            {passwordError && <p className="text-red-500 text-xs mt-1">{passwordError}</p>}
          </div>

          {/* Login Button */}
          <button
            type="submit"
            disabled={loading}
            className={`w-full py-2 rounded-lg font-bold text-white transition duration-200 ${loading ? "bg-green-300 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"
              }`}
          >
            {loading ? "Logging in..." : "LOGIN"}
          </button>
          {/* <div className="flex items-start absolute bottom-0 left-0"> */}
            <p onClick={() => navigate("/signIn")} className="text-xs flex cursor-pointer"><FaAngleDoubleLeft />Prev</p>
          {/* </div> */}
        </form>
      </div>

      {/* Animations */}
      <style>{`
        .animate-fadeIn {
          animation: fadeIn 0.8s ease-in-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default Login;
